import { PrincipalIdSchema } from "@core/domains/identity";
import { identity } from "@core/foundation/function";
import { createModel, createModelSchemas } from "@core/foundation/model";
import { z } from "@core/zod";

const GithubConnectionStatusSchema = z.enum(["active", "disconnected"]);

export const GithubConnection = createModel({
  create: item => {
    return { ...item };
  },
  schemas: createModelSchemas({
    base: z.object(
      {
        githubAccountId: z.int().nonnegative(),
        githubAccountLogin: z.string(),
        installationId: z.int().nonnegative(),
        principalId: PrincipalIdSchema,
        status: GithubConnectionStatusSchema,
      },
      {
        githubAccountId:
          "The id of the GitHub account the app is installed on.",
        githubAccountLogin:
          "The login of the GitHub account the app is installed on.",
        installationId: "The id of the GitHub App installation.",
        principalId: "The id of the principal the connection belongs to.",
        status: "The connection's status, either active or disconnected.",
      },
    ),
    derive: {
      create: identity,
      recovery: identity,
      update: schema =>
        schema.pick({ installationId: true, status: true }).partial(),
    },
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface GithubConnection
  extends z.infer<typeof GithubConnection.schema> {}
